import * as React from 'react';
import { Button } from '@cian/ui-kit';
import * as styles from './BrokerButton.css';

interface IBrokerButtonProps {
  onClick?(event: React.MouseEvent<HTMLButtonElement>): void;
}

export const BrokerButton: React.FC<IBrokerButtonProps> = ({ onClick }) => {
  return (
    <div data-mark="BrokerButton" className={styles['button']}>
      <Button onClick={onClick} size="M" theme="fill_success_primary" type="button" fullWidth>
        Продать квартиру в ЖК
      </Button>
    </div>
  );
};
